import { NavLink } from "react-router-dom";
import {
    Home,
    Network,
    Award,
    ScrollText,
    LockKeyhole,
    ClipboardList,
    MessageCircle,
    Gamepad2,
} from "lucide-react";
import Logo from "../Logo";
import { DISCORD_URL, ROBLOX_URL } from "../../data/staffData";

export const NAV = [
    { to: "/", label: "Início", icon: Home, id: "inicio" },
    { to: "/hierarquia", label: "Hierarquia", icon: Network, id: "hierarquia" },
    { to: "/ranks", label: "Ranks", icon: Award, id: "ranks" },
    { to: "/regras", label: "Regras Staff", icon: ScrollText, id: "regras" },
    { to: "/regras-pago", label: "Regras Staff Pago", icon: LockKeyhole, id: "regras-pago" },
    { to: "/formulario-staff", label: "Formulário Staff", icon: ClipboardList, id: "formulario-staff" },
];

export function NavItems({ onNavigate }) {
    return (
        <nav className="flex-1 space-y-1 px-3 py-5">
            {NAV.map((item) => (
                <NavLink
                    key={item.id}
                    to={item.to}
                    end={item.to === "/"}
                    onClick={onNavigate}
                    data-testid={`nav-link-${item.id}`}
                    className={({ isActive }) =>
                        `group relative flex items-center gap-3 rounded-lg px-3.5 py-2.5 text-sm font-medium transition-colors duration-200 ${
                            isActive
                                ? "bg-violet-500/10 text-white"
                                : "text-gray-400 hover:bg-white/5 hover:text-gray-100"
                        }`
                    }
                >
                    {({ isActive }) => (
                        <>
                            {isActive && (
                                <span className="absolute left-0 top-1/2 h-5 w-1 -translate-y-1/2 rounded-full bg-gradient-to-b from-violet-500 to-blue-500" />
                            )}
                            <item.icon
                                className={`h-[18px] w-[18px] transition-colors ${
                                    isActive
                                        ? "text-violet-400"
                                        : "text-gray-500 group-hover:text-gray-300"
                                }`}
                            />
                            {item.label}
                        </>
                    )}
                </NavLink>
            ))}
        </nav>
    );
}

export function SidebarFooter() {
    return (
        <div className="border-t border-white/[0.07] px-4 py-4">
            <div className="flex gap-2">
                <a
                    data-testid="sidebar-discord-link"
                    href={DISCORD_URL}
                    target="_blank"
                    rel="noreferrer"
                    aria-label="Discord da equipe"
                    className="flex h-9 flex-1 items-center justify-center gap-2 rounded-lg border border-indigo-500/30 bg-indigo-500/10 text-xs font-semibold text-indigo-300 transition-colors hover:bg-indigo-500/20"
                >
                    <MessageCircle className="h-4 w-4" /> Discord
                </a>
                <a
                    data-testid="sidebar-roblox-link"
                    href={ROBLOX_URL}
                    target="_blank"
                    rel="noreferrer"
                    aria-label="Grupo do Roblox"
                    className="flex h-9 flex-1 items-center justify-center gap-2 rounded-lg border border-white/10 bg-white/5 text-xs font-semibold text-gray-300 transition-colors hover:bg-white/10"
                >
                    <Gamepad2 className="h-4 w-4" /> Roblox
                </a>
            </div>
            <p className="mt-3 flex items-center gap-2 px-1 text-[11px] text-gray-500">
                <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-emerald-400" />
                Escola Staff • Comunidade Roblox
            </p>
            <NavLink
                to="/admin"
                data-testid="sidebar-admin-link"
                className="mt-2 flex items-center gap-2 px-1 text-[11px] font-semibold text-gray-600 transition-colors hover:text-violet-400"
            >
                <LockKeyhole className="h-3 w-3" /> Administração
            </NavLink>
        </div>
    );
}

export default function Sidebar() {
    return (
        <aside
            data-testid="sidebar"
            className="fixed inset-y-0 left-0 z-40 hidden w-64 flex-col border-r border-white/[0.07] bg-[#0C0E15]/90 backdrop-blur-xl lg:flex"
        >
            <div className="flex items-center gap-3 border-b border-white/[0.07] px-5 py-5">
                <Logo size={38} />
                <div>
                    <p className="font-display text-sm font-extrabold tracking-wide text-white">
                        EQUIPE STAFF
                    </p>
                    <p className="font-code text-[10px] font-medium tracking-[0.3em] text-violet-400">
                        [EBH1]
                    </p>
                </div>
            </div>
            <NavItems />
            <SidebarFooter />
        </aside>
    );
}
